module.exports = __webpack_public_path__ + "static/media/oasis-kullanim-kilavuzu.875b2622.pdf";